/* eslint-disable angular/factory-name */
angular.
module("digiexam.services").
factory("examState", function examState() {
	"use strict";
	return {
		EMPTY: 0,
		DRAFT: 1,
		FINAL: 2,
		BLANK: 3,
	};
});
